export const DO_NOT_REMINDER_TODAY = 'doNotReminderToday'
export const CLAW_STORE_FILTER_CONDITION = 'clawStoreFilterCondition'
export const CHART_BOOKMARK_INDEX = 'chartBookmarkIndex'
export const DEFAULT_CHART_BOOKMARK_INDEX: number = 1
export const STORE_INFO = 'store-info'
export const EGM_RC_SETTING_JSON = 'egmRcSettingJson'
export const STORAGE_USER = 'storage-user'
export const EGM_CONNECTION_STATUS_INFO = 'egmConnectionStatusInfo'
export const FROM_THIRD_PARTY_ID = 'from-third-party-id'
export const FROM_THIRD_PARTY_TYPE = 'from-third-party-type'
export const REMEMBER_ME = 'rememberMe'
export const MEMBER_JOIN = 'member-join'
export const SELECTED_PCB_NAME = 'selectedPcbName'
export const GOODS_IS_VISIBLE_SWITCH = 'goodsIsVisibleSwitch'
export const SYSTEM_ANNOUNCEMENT_CACHE = 'systemAnnouncementCache'
export const CONTEXT_SWITCH_USER_ID = 'context-switch-user-id'
export const LAST_ACTIVITY_AT = 'last-activity-at'
